import { render } from "./Usecase.vue?vue&type=template&id=4dd1e5ef&scoped=true&ts=true&lang=pug"
import script from "./Usecase.vue?vue&type=script&lang=ts"
export * from "./Usecase.vue?vue&type=script&lang=ts"

import "./Usecase.vue?vue&type=style&index=0&id=4dd1e5ef&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd1e5ef"]])

export default __exports__